import React from "react"
import Spacer from "./spacer"

const Quote = ({ quote, author }) => {
  return (
    <>
      <div className='flex flex-column align-center pl60 m-p40'>
        <div>
          <h4 className='h3 text-normal story--quote'>{quote}</h4>
          <span className='with-dot small pl20'>{`[${author}]`}</span>
        </div>
      </div>
      <Spacer />
    </>
  )
}

export default Quote
